import format from "date-fns/format";
import { getYear, parseISODate } from "../date";
import isBefore from "date-fns/isBefore";
import isAfter from "date-fns/isAfter";
import isEqual from "date-fns/isEqual";

/**
 * Calendar
 */
export default function calendar(el, props) {
  let userInput = null;
  const themeClass = props.themeClass || null;
  const inputEl = el.querySelector(props.inputEl);
  const maxDate = props.maxDate ? parseISODate(props.maxDate) : new Date();
  const minDate = props.minDate
    ? parseISODate(props.minDate)
    : new Date("1900-01-01");
  const defaultDate = props.allowBlank ? null : new Date();
  const selectedDate = props.selectedDate
    ? parseISODate(props.selectedDate)
    : defaultDate;

  let picker;

  import("../vendor/pikaday").then(({ default: Pikaday }) => {
    picker = new Pikaday({
      defaultDate: selectedDate,
      setDefaultDate: selectedDate,
      field: inputEl,
      firstDay: 1,
      format: "d MMMM yyyy",
      maxDate: maxDate,
      minDate: minDate,
      theme: themeClass,
      keyboardInput: false,
      yearRange: [1900, getYear()],
      toString(date, dateFormat) {
        return format(date, dateFormat);
      },
      onSelect: function(date) {
        if (userInput) {
          const parsed = parseISODate(userInput);
          if (parsed === "Invalid Date") {
            // Reset the value
            inputEl.value = userInput;
          } else {
            // Check date is in range
            const inDateRange =
              isEqual(parsed, maxDate) ||
              isEqual(parsed, minDate) ||
              (isBefore(parsed, maxDate) && isAfter(parsed, minDate));
            if (inDateRange) {
              // Set the value in the picker itself
              userInput = null;
              picker.setDate(parsed);
            } else {
              // Reset the value to nothing
              inputEl.value = "";
              userInput = null;
            }
          }
        }
      }
    });
  });

  inputEl.addEventListener("input", onInput);

  function onInput(e) {
    userInput = e.target.value;
  }

  return {
    destroy: () => {
      if (picker) {
        picker.destroy();
      }
      inputEl.removeEventListener("input", onInput);
    }
  };
}
